import * as React from "react";

import DeprecatedLabeledControl from "@v1/components/common/designSystem/DeprecatedLabeledControl";
import Stepper from "@v1/components/editor/page/element-editor/components/modifiers/Stepper";

type IntegerSelectorProps = {
  value: number;
  onChange: (newValue: number) => void;
  label?: string;
  min?: number;
};

export const IntegerSelector = ({
  value,
  onChange,
  label,
  min = 1,
}: IntegerSelectorProps) => {
  const content = (
    <div className="flex flex-row gap-2">
      <Stepper
        value={value}
        field="integerSelector"
        minValue={min}
        onChange={onChange}
      />
    </div>
  );
  if (label) {
    return (
      <DeprecatedLabeledControl
        label={label}
        size="sm"
        containerClassName="flex-1"
      >
        {content}
      </DeprecatedLabeledControl>
    );
  }
  return content;
};
